import React, { useState } from "react";
import { Button, Col, ListGroup, Row, Spinner } from "react-bootstrap";
import { BsFileEarmarkZip, BsFilePdf } from "react-icons/bs";
import PrivateApi from "../../services/PrivateApiService";

const ZipsListItem = (props) => {

    const API = new PrivateApi();
    const [loading, setLoading] = useState(false);


    const downloadClickHandler = (fileName) => {
        setLoading(true);
        API.get_ArchiveDownload(fileName)
            .then(res => {
                let data = res.data;
                if (data.file !== undefined) {
                    const linkSource = `data:application/zip;base64,${data.file}`;
                    const downloadLink = document.createElement('a');

                    downloadLink.href = linkSource;
                    downloadLink.download = fileName;
                    downloadLink.click();
                    setLoading(false);
                }
            })
            .catch(e => {
                setLoading(false);
            })
    };


    return (
        <ListGroup.Item key={props.zip.name}>
            <Row className="align-items-center">
                <Col xs="12" md="12" xl="1" className="text-center">
                    {props.zip.name.includes(".pdf")?
                        <BsFilePdf className="text-danger" size={30} />
                    :
                        <BsFileEarmarkZip className="text-warning" size={30} />
                    }
                </Col>
                <Col xs="12" md="12" xl="6">
                    <small className="text-energo">Dateiname</small><br />
                    {props.zip.name}
                </Col>
                <Col xs="6" md="4" xl="2">
                    <small className="text-energo">Größe</small> <br />
                    {props.zip.size.toFixed(2)} MB
                </Col>
                <Col xs="6" md="4" xl="2">
                    <small className="text-energo">Erstellungsdatum</small> <br />
                    {new Date(props.zip.downloaded * 1000).toLocaleDateString('DE-de')} {new Date(props.zip.downloaded * 1000).toLocaleTimeString('DE-de', {hour: '2-digit', minute: '2-digit'})}
                </Col>
                <Col xs="12" md="4" xl="1" className="text-end">
                    {!loading? 
                        <Button onClick={() => downloadClickHandler(props.zip.name)} className="btn-energo rounded-pill" size="sm">Download</Button>
                    :
                        <div className="align-items-center">
                            <Spinner animation="border" size="sm" className="text-energo" /> &nbsp;
                            <small>Download wird vorbereitet...</small>
                        </div>
                    }
                </Col>
            </Row>
        </ListGroup.Item>
    )
}

export default ZipsListItem;